<template>
  <div :class="['card-map-root', position ? position : 'right']" id="card-map">
    <!-- Close Button (outside the link) -->
    <div class="cross-card-map" @click='$emit("unselect", idMarker)'>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <!-- Entire card is now wrapped in a link -->
    <a class="card-map" :href="'/reservation-hotel/' + lodging.slug">
      <img class="hub-img" :src="formatSource()" :alt="lodging.name">

      <div class="sticker-hub d-flex mt-4 pl-2" v-if="lodging.score">
        <img :src="greenNotePicto((lodging.score).toFixed())" :alt="(lodging.score).toFixed()">
        <div class="sticker-info d-flex">
          <p class="raleway-reg-p13 mb-0 pl-1 pr-2"><b>{{ (lodging.score).toFixed() }}</b>/10</p>
          <p class="raleway-reg-p13 mb-0 pl-1 pr-2">Green note</p>
        </div>
      </div>

      <div class="card-hub-info px-2">
        <div class="hub-header d-flex">
          <h1 class="raleway-bold-h3 no-translate">{{ lodging.name }}</h1>
        </div>

        <div class="standing" v-if="parseInt(lodging.standing, 10)">
          <img src="../../images/Etoiles.svg" alt="Etoile remplie" v-for='i in parseInt(lodging.standing, 10)' :key='i'>
        </div>

        <p class="description-hub raleway-reg-p13" v-if="fullLocation">{{ fullLocation }}</p>

        <div class="catch-hub" v-if='lodging.lodging_description.catch_sentence'>
          <p class="merriweather-italic">{{ lodging.lodging_description.catch_sentence }}</p>
        </div>
        <div class="catch-hub" v-else>
          <p class="merriweather-italic">Un havre aussi éco-responsable que luxueux</p>
        </div>

        <p class="raleway-reg-p13">À partir de <strong>{{ lodging.lowest_price }}€/nuit</strong></p>
        <p class="merriweather-italic lodging-type">
          {{ typeLabels[lodging.type] || "Lodges et lieux insolites" }} - 
          {{ lodging.is_entire ? lodging.rooms_count : 1 }} 
          {{ lodging.is_entire ? lodging.rooms_count > 1 ? 'chambres' : 'chambre' : 'chambre' }}
        </p>

      </div>
    </a>
  </div>
</template>

<script>

  export default{
   name: 'card-map',
   props: ['lodging', 'country', 'user', 'idMarker', 'position'],
    data() {
      return {
        wishlistLodgings: null,
        typeLabels: {
          Hotel: "Hôtels",
          "Maison et Villa": "Maisons et Villas",
          Guestroom: "Chambres d'Hôtes",
          Lodge: "Lodges et Lieux Insolites",
          Appartment: "Appartements",
          Chalet: "Chalets"
        }
      }
    },
    methods: {
      greenNotePicto(score){
        if (score === `${score}`){
          return require(`../../images/greennote ${score}.svg`)
        } else {
          return require("../../images/blanc.png")
        }
      },
      formatSource() {
        if (this.lodging.photo_banner) {
          return this.lodging.photo_banner
        } else {
          return 'https://media.gettyimages.com/photos/bedroom-in-new-luxury-home-picture-id1194686012?k=6&m=1194686012&s=612x612&w=0&h=IX6Bjhwa5M5NtCtlKll-FFi_hn5lxrPwiUImH3fsZZ0=';
        }
      },
      async toggleLike() {
        if (this.user) {
          const response = await fetcher.patch('/wishlists/'+ 1, { lodging_id: this.lodging.id })
          this.wishlistLodgings = response.data.lodgings;
        } else {
          this.$emit('connection');
        }
      },
      isIncludeInWishlist() {
        if (this.wishlistLodgings) {
          for (const lodging of this.wishlistLodgings) {
            if (lodging.id === this.lodging.id) {
              return true
            }
          }
        }
        return false
      },
      async fetchWishlist() {
        if (this.user) {
        const response = await fetcher.get('/wishlists.json')
        this.wishlistLodgings = response.data.lodgings
      }
      }
    },
    computed: {
      fullLocation() {
        const countryName = this.country?.name || this.lodging.country?.name;
        const { region, department, city } = this.lodging;
        return [
          countryName,
          region?.name,
          department?.name,
          city?.name
        ].filter(Boolean).join(', ');
      }
    },
    mounted() {
      console.log('[CardMap] lodging data:', this.lodging);
      this.fetchWishlist();
    },
    beforeMount() {
      this.fetchWishlist()
    }
 }
</script>

<style lang="scss" scope='app/assets/stylesheets/components/map'>
#card-map {
  text-decoration: none;
  color: inherit;
  padding-left: .5rem;

  * {
    text-decoration: none !important;
    color: inherit !important;
  }
}
#card-map.left {
  left: 5%;
  right: auto;
  padding: 0px;

}

#card-map.right {
  right: 5%;
  left: auto;
  padding: 0px;
}
.lodging-type {
  font-size: 12px;
  color: grey;
}

.cross-card-map {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s ease;
  color: #666;

  &:hover {
    background: rgba(255, 255, 255, 1);
    color: #333;
    transform: scale(1.1);
  }
}
</style>
